<template>
  <div class="order-container">
    <el-tabs v-model="activeTab" type="card" class="order-tab-container">
      <el-tab-pane label="基本信息" name="1">
        <order-tab-content>
          <el-empty v-if="!order" description="暂无数据"/>
          <order-base v-else :order="order"/>
        </order-tab-content>
      </el-tab-pane>
      <el-tab-pane label="融资信息" name="2">
        <order-tab-content>
          <el-empty v-if="!orderFinance" description="暂无数据"/>
          <order-finance v-else :orderFinance="orderFinance"/>
        </order-tab-content>
      </el-tab-pane>
      <el-tab-pane label="还款记录" name="3">
        <el-empty v-if="!orderRepaymentList" description="暂无数据"/>
        <order-repayment v-else :repaymentList="orderRepaymentList" @update:repaymentList="updateOrderRepaymentList"
                         :height="contentHeight"/>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import {hasPer} from "@/utils/common";
import OrderBase from "@/views/order/info/componet/orderBase.vue";
import OrderFinance from "@/views/order/info/componet/orderFinance.vue";
import OrderRepayment from "@/views/order/info/componet/orderRepayment.vue";
import OrderTabContent from "@/views/order/info/tab/orderTabContent.vue";

export default {
  name: "orderTab",
  components: {
    OrderTabContent,
    OrderRepayment,
    OrderFinance,
    OrderBase,
  },
  props: {
    orderDetail: {
      type: Object,
      required: true
    },
    contentHeight: {
      type: Number,
      require: true,
      default: 500
    }
  },
  data() {
    return {
      activeTab: '1'
    };
  },
  computed: {
    order() {
      return this.orderDetail.order;
    },
    orderFinance() {
      return this.orderDetail.orderFinance;
    },
    orderRepaymentList() {
      return this.orderDetail.orderRepaymentList;
    }
  },
  mounted() {
  },
  created() {
  },
  methods: {
    hasPer,
    updateOrderRepaymentList(val) {
      this.$emit('update:orderRepaymentList', val)
    }
  }
};
</script>

<style scoped>
</style>
